
import { StrategyWithDetails } from "@/types/strategy-types";

export const ITEMS_PER_PAGE = 10;

export const getRiskLabel = (level: number | undefined) => {
  if (level === undefined) return { text: 'Unknown', color: 'text-gray-500' };
  
  const labels: Record<number, { text: string; color: string }> = {
    1: { text: 'Low', color: 'text-green-500' },
    2: { text: 'Medium', color: 'text-yellow-500' },
    3: { text: 'High', color: 'text-red-500' },
  };
  return labels[level] || { text: 'Unknown', color: 'text-gray-500' };
};

export type SortField = 'name' | 'exchange' | 'risk_level' | 'min_investment' | 'created_at';
export type SortOrder = 'asc' | 'desc';

export const sortStrategies = (
  strategies: StrategyWithDetails[],
  sortField: SortField,
  sortOrder: SortOrder
): StrategyWithDetails[] => {
  return [...strategies].sort((a, b) => {
    let comparison = 0;
    
    switch (sortField) {
      case 'name':
        comparison = String(a.name || a.strategy_name || '').localeCompare(String(b.name || b.strategy_name || ''));
        break;
      case 'exchange':
        comparison = String(a.exchange || '').localeCompare(String(b.exchange || ''));
        break;
      case 'risk_level':
      case 'min_investment':
        comparison = Number(a[sortField] || 0) - Number(b[sortField] || 0);
        break;
      case 'created_at':
        const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
        const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
        comparison = dateA - dateB;
        break;
      default:
        return 0;
    }

    return sortOrder === 'asc' ? comparison : -comparison;
  });
};
